module.exports = __webpack_public_path__ + "img/bl.93278d77.svg";